export function getEditFormConfig() {
	return {
		DEFAULT: [
			{
				el: "el-input",
				label: "结局名称",
				name: "name",
				attrs: {
					clearable: true,
					placeholder: "请输入结局名称",
				},
			},
			{
				el: "el-input",
				label: "标题",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入标题",
				},
			},
			{
				el: "rich-text",
				label: "解析",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},

			{
				el: "rich-text",
				label: "建议",
				name: "suggest",
				attrs: {
					keyWord: "suggest",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		]

	};
}

export function getColumnConfig() {
	return {
		DEFAULT: [
			{
				el: "el-table-column",
				label: "结局名称",
				name: "name",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "标题",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "解析",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "建议",
				name: "suggest",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},

		],
	};
}
